export default __webpack_public_path__ + "static/media/hoitojakso_osastolla.c75072c9.svg";